<template>
  <form
    class="new-salary-receipt"
    @submit.prevent="onSubmit"
  >
    <div class="columns is-multiline is-centered">
      <div class="column is-6">
        <PayrollDetails
          :loading="isLoading"
          :disabled="isLoading"
        />
      </div>
      <div class="column is-6">
        <PayrollReceiver
          :loading="isLoading"
          :disabled="isLoading"
        />
      </div>
      <div class="column is-12">
        <PayrollPercepts
          :loading="isLoading"
          :disabled="isLoading"
        />
      </div>

      <div class="column is-12 action-buttons">
        <div
          v-if="stamped || canceled"
          class="field is-grouped"
        >
          <p class="control">
            <RouterLink
              class="button"
              :class="{ 'is-loading': isLoading }"
              :disabled="isLoading"
              :to="{ name: 'SaleNoteList', query: { size: 20, page: 1 } }"
            >
              Regresar
            </RouterLink>
          </p>
        </div>
        <div
          v-else
          class="field is-grouped"
        >
          <p class="control">
            <RouterLink
              class="button"
              :class="{ 'is-loading': isLoading }"
              :disabled="isLoading"
              :to="{ name: 'SalaryReceiptList', query: { size: 20, page: 1 } }"
            >
              Regresar
            </RouterLink>
          </p>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';

export default {
  name: 'SalaryReceiptDetail',
  components: {
    PayrollDetails: () => import(/* webpackChunkName: "salary-receipt-detail" */ '@/components/Admin/Payroll/SalaryReceiptDetail.vue'),
    PayrollReceiver: () => import(/* webpackChunkName: "payroll-basic-receiver" */ '@/components/Admin/Payroll/PayrollBasicReceiver.vue'),
    PayrollPercepts: () => import(/* webpackChunkName: "salary-receipt-percepts" */ '@/components/Admin/Payroll/SalaryReceiptPercepts.vue'),
  },
  data() {
    return {
      isLoading: false,
      stamp: false,
    };
  },
  computed: {
    ...mapState({
      stamped: state => state.payroll.operation.isSaleNote,
      status: state => state.payroll.operation.status,
    }),
    canceled() {
      return [201, 202].includes(this.status);
    },
  },
  async beforeMount() {
    this.isLoading = true;
    await this.getPayrollByUuid(this.$route.params.uuid);
    this.isLoading = false;
  },
  methods: {
    ...mapMutations({
      setPayrollValues: 'payroll/setValues',
    }),
    ...mapActions({
      getPayrollByUuid: 'payroll/getByUuid',
    }),
  },
};
</script>

<style scoped>
.new-salary-receipt {
  padding: 1rem;
}

.action-buttons {
  display: flex;
  justify-content: flex-end;
}

@media screen and (min-width: 1280px) {
  .box {
    flex-direction: column;
  }

  .label.is-centered::before {
    top: inherit;
  }
}
</style>
